import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronLeft, ChevronRight, Home, BookOpen } from 'lucide-react';
import { bookContent } from '../data/bookContent';

export const ChapterNavigation = ({ currentChapter }) => {
  const totalChapters = bookContent.chapters.length;
  const prevChapter = currentChapter > 1 ? currentChapter - 1 : null;
  const nextChapter = currentChapter < totalChapters ? currentChapter + 1 : null;

  return (
    <div 
      data-testid="chapter-navigation"
      className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-md border-t border-stone-100 py-4 px-4 md:px-8 z-50"
    >
      <div className="max-w-4xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          {prevChapter ? (
            <Link
              to={`/chapter/${prevChapter}`}
              data-testid="prev-chapter-btn"
              className="flex items-center gap-1 px-4 py-2 text-charcoal-light hover:text-sage transition-colors rounded-lg hover:bg-sage/10"
            >
              <ChevronLeft className="w-5 h-5" />
              <span className="hidden sm:inline">Previous</span>
            </Link>
          ) : (
            <div className="w-24" />
          )}
        </div>

        <div className="flex items-center gap-4">
          <Link
            to="/"
            data-testid="home-nav-btn"
            className="p-2 text-charcoal-light hover:text-sage transition-colors rounded-lg hover:bg-sage/10"
          >
            <Home className="w-5 h-5" />
          </Link>
          <Link
            to="/contents"
            data-testid="contents-nav-btn"
            className="p-2 text-charcoal-light hover:text-sage transition-colors rounded-lg hover:bg-sage/10"
          >
            <BookOpen className="w-5 h-5" />
          </Link>
          <span className="text-sm text-charcoal-light">
            {currentChapter} / {totalChapters}
          </span>
        </div>

        <div className="flex items-center gap-2">
          {nextChapter ? (
            <Link
              to={`/chapter/${nextChapter}`}
              data-testid="next-chapter-btn"
              className="flex items-center gap-1 px-4 py-2 bg-sage text-white hover:bg-sage-dark transition-colors rounded-full"
            >
              <span className="hidden sm:inline">Next</span>
              <ChevronRight className="w-5 h-5" />
            </Link>
          ) : (
            <Link
              to="/journal"
              data-testid="journal-nav-btn"
              className="flex items-center gap-1 px-4 py-2 bg-gold text-white hover:bg-gold/90 transition-colors rounded-full"
            >
              <span>My Journal</span>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
